import React from 'react';

type BadgeVariant = 'default' | 'success' | 'warning' | 'error' | 'brand';

const variantStyles: Record<BadgeVariant, string> = {
  default: 'bg-slate-100 text-slate-600',
  success: 'bg-emerald-50 text-emerald-700',
  warning: 'bg-amber-50 text-amber-700',
  error: 'bg-red-50 text-red-700',
  brand: 'bg-brand-50 text-brand-700',
};

interface BadgeProps {
  children: React.ReactNode;
  variant?: BadgeVariant;
  className?: string;
}

const Badge: React.FC<BadgeProps> = ({ children, variant = 'default', className = '' }) => (
  <span className={`badge ${variantStyles[variant]} ${className}`}>
    {children}
  </span>
);

export default Badge;
